const toInt = (v) => (v === "" || v === null ? null : parseInt(v, 10));
const toFloat = (v) => (v === "" || v === null ? null : parseFloat(v));

export { toInt, toFloat };
